/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {UserService} from "../../../../services/user.service";
import {Component, Input, Output, EventEmitter, OnInit} from "@angular/core";
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';
import {Observable, Observer} from 'rxjs';
import { EntityService } from "../../../../services/entity.service";

import {InstanceData} from "../../../../models/instance-data";
import {User} from "../../../../models/user";
import { switchMap } from "rxjs/operators";

@Component({
  selector: 'app-user-selector',
  templateUrl: './user-selector.component.html'
})
export class UserSelectorComponent implements OnInit {

  @Input()
  mData: InstanceData;

  @Output()
  removeClicked = new EventEmitter<void>();

  typeaheadValue: string;
  typeaheadLoading: boolean;
  typeaheadNoResults: boolean;
  entities: Observable<any>;  

 constructor(
	private mUserService: UserService,
	private mEntityService: EntityService
  ) {}

  ngOnInit(): void {
    //KHT 08/17/2021 - updated to new ngx-bootstrap standard
    this.entities = new Observable((observer: Observer<string>) => {
      observer.next(this.typeaheadValue);
    }).pipe(
      switchMap((query: string) => {
          if(query){
              return this.search(query);
          }
      })
  )

	this.loadUser();
  }

    changeTypeaheadLoading(e: boolean): void {
        this.typeaheadLoading = e;
    }
    
    typeaheadOnSelect(e: TypeaheadMatch): void {
        console.log('Selected value: ', e.item);
        this.mData.value = e.item.id;
		if (this.mData.object_value != null) {
			this.mData.object_value.user_reference.id = e.item.id;
		}
    }

  private search(token: string): Observable<any[]> {
	  return this.mEntityService.searchUser(token);
  }

  private async loadUser(): Promise<void> {
	const user: User = await this.mUserService.getUserForId(Number(this.mData.value));
	if (user != null) {
		this.typeaheadValue = user.firstName + " " + user.lastName;
	}
  }
}
